export default __webpack_public_path__ + "static/6-e7606b5ce8818f7834fb56c0b0542be5.jpg";